import React from "react";
import "./style.css";

export const CoursesFeature = ({title, icon, text}) => {

  return (
    <div className="course_feature">
      <img loading="lazy" className="icon" src={icon} alt={title} />
      <div className="course_feature_title" dangerouslySetInnerHTML={{__html: title}}></div>
      <div className="course_feature_text">{text}</div>
    </div>
  );
};